export default __webpack_public_path__ + "static/media/GATM.0ea2b08a.png";